// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__mPbXL","image":"App_image__11-4s","name":"App_name__YHHqm"};